import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_DEPTSTRUCTURE,
  GET_DEPARTMENT,
  DELETE_DEPARTMENT,
  UPDATE_DEPARTMENT,
  ADD_NEW_DEPARTMENT,
} from "./actionType";

import {
  getDepartmentSuccess,
  getDepartmentFail,
  deleteDepartmentSuccess,
  deleteDepartmentFail,
  updateDepartmentSuccess,
  updateDepartmentFail,
  addDepartmentSuccess,
  addDepartmentFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getDepartmentApi,
  updateDepartmentApi,
  deleteDepartmentApi,
  addNewDepartmentApi
} from "../../helpers/backend_helper";

function* getDepartment({ payload: department , path}) {
  try {
    const response = yield call(getDepartmentApi, department, path);
    yield put(getDepartmentSuccess(GET_DEPARTMENT, response.data));
  } catch (error) {
    yield put(getDepartmentFail(GET_DEPARTMENT, error));
  }
}

function* getDeptStructure({ payload: department , path}) {
  try {
    const response = yield call(getDepartmentApi, department, path);
    yield put(getDepartmentSuccess(GET_DEPTSTRUCTURE, response.data));
  } catch (error) {
    yield put(getDepartmentFail(GET_DEPTSTRUCTURE, error));
  }
}

function* onUpdateDepartment({ payload: department }) {
  try {
    const response = yield call(updateDepartmentApi, department);
    yield put(updateDepartmentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateDepartmentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteDepartment({ payload: department }) {
  try {
    const response = yield call(deleteDepartmentApi, department);
    yield put(deleteDepartmentSuccess({ department, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteDepartmentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewDepartment({ payload: department }) {
  try {
    const response = yield call(addNewDepartmentApi, department);
    yield put(addDepartmentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addDepartmentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetDeptStructureAll() {
  yield takeEvery(GET_DEPTSTRUCTURE, getDeptStructure);
}

export function* watchGetDepartment() {
  yield takeEvery(GET_DEPARTMENT, getDepartment);
}

export function* watchUpdateDepartment() {
  yield takeEvery(UPDATE_DEPARTMENT, onUpdateDepartment);
}

export function* watchDeleteDepartment() {
  yield takeEvery(DELETE_DEPARTMENT, onDeleteDepartment);
}

export function* watchAddNewDepartment() {
  yield takeEvery(ADD_NEW_DEPARTMENT, onAddNewDepartment);
}

function* departmentSaga() {
  yield all([
    fork(watchGetDeptStructureAll),
    fork(watchGetDepartment),
    fork(watchDeleteDepartment),
    fork(watchUpdateDepartment),
    fork(watchAddNewDepartment)
  ]);
}

export default departmentSaga;
